import { DokumentTypMappingEventTyp } from '@core/domain';
import React from 'react';
import type { FieldErrors, UseFormRegister } from 'react-hook-form';
import { DokumentTypFormInput } from '@/pages/Konfiguration/DokumentTypen/schemas/dokumenttypenerstellen';

interface Props {
  register: UseFormRegister<DokumentTypFormInput>;
  errors: FieldErrors<DokumentTypFormInput>;
}

export const DokumentTypBaseFieldsBox: React.FC<Props> = ({
  register,
  errors,
}) => (
  <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
    <div>
      <span className="text-xs font-semibold text-gray-500 uppercase tracking-wide">
        Dokumenttyp
      </span>
      <input
        {...register('dokumentTyp')}
        placeholder="Dokumenttyp"
        className="w-full px-3 py-2 text-sm border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
      />
      <span className="text-xs font-semibold uppercase tracking-wide text-red-700 mt-1 min-h-4">
        {errors.dokumentTyp && 'Dokumenttyp ist ein Pflichtfeld.'}
      </span>
    </div>

    <div>
      <span className="text-xs font-semibold text-gray-500 uppercase tracking-wide">
        Event name
      </span>
      <input
        {...register('eventName')}
        placeholder="Event Name"
        className="w-full px-3 py-2 text-sm border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
      />
      <span className="text-xs font-semibold uppercase tracking-wide text-red-700 mt-1 min-h-4">
        {errors.eventName && 'Event Name ist ein Pflichtfeld.'}
      </span>
    </div>

    <div>
      <span className="text-xs font-semibold text-gray-500 uppercase tracking-wide">
        Event Typ
      </span>
      <select
        {...register('eventTyp')}
        className="w-full px-3 py-2 text-sm border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
      >
        {DokumentTypMappingEventTyp.options.map((option) => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
      </select>
    </div>
  </div>
);
